import { api } from './client';

// ============================================
// Filter Options
// ============================================

export interface AccountOption {
  account_id: string;
  account_name: string;
  platform: string;
}

export interface FilterOptions {
  platforms: string[];
  accounts: AccountOption[];
}

// ============================================
// Summary (KPI Cards)
// ============================================

export interface MetricValue {
  value: number;
  change: number; // percentage change vs previous period
}

export interface SummaryData {
  spend: MetricValue;
  roas: MetricValue;
  cpc: MetricValue;
  cpm?: MetricValue;
  purchase_count: MetricValue;
  cpa: MetricValue;
}

export interface AccountSummaryData {
  account_count: number;
  balance: number;
  balance_available: boolean;
  balance_missing_count: number;
  balance_currency: string;
  balance_mixed_currency: boolean;
  available_days: number;
  active_count: number;
  inactive_count: number;
  last_7_days_avg_spend: number;
}

// ============================================
// Trend (Channel Spend Chart)
// ============================================

export interface TrendPoint {
  date: string;
  platform: string;
  spend: number;
}

// ============================================
// Campaigns Table
// ============================================

export interface DashboardCampaign {
  campaign_id: string;
  campaign_name: string;
  platform: string;
  account_id: string;
  account_name?: string;
  spend: number;
  revenue: number;        // purchase_revenue (转化金额)
  roas: number;
  cpc: number;            // 单次点击费用
  cpm?: number;           // 千次展示费用（旧数据可能缺失）
  cpa: number;
  purchase_count: number; // 购买数量
  status: string;
}

// ============================================
// Shared params
// ============================================

export interface DashboardParams {
  brand_id?: string;
  site_id?: string;
  date_range?: string;   // today|yesterday|7d|30d|custom
  start_date?: string;
  end_date?: string;
  platform?: string;
  account_id?: string;
}

// ============================================
// API
// ============================================

export const dashboardApi = {
  getFilterOptions: (params?: { brand_id?: string; site_id?: string; scope?: 'dashboard_read' | 'dashboard_export' | 'platform_account_read' }) =>
    api.get<{ code: number; data: FilterOptions }>('/dashboard/filter-options', { params }),

  getSummary: (params: DashboardParams) =>
    api.get<{ code: number; data: SummaryData }>('/dashboard/summary', { params }),

  getAccountSummary: (params: DashboardParams) =>
    api.get<{ code: number; data: AccountSummaryData }>('/dashboard/account-summary', { params }),

  getTrend: (params: DashboardParams) =>
    api.get<{ code: number; data: TrendPoint[] }>('/dashboard/trend', { params }),

  getCampaigns: (params: DashboardParams & { limit?: number }) =>
    api.get<{ code: number; data: DashboardCampaign[] }>('/dashboard/campaigns', { params }),
};
